import { formatAddressUS } from '@caresend/utils';
import { getStore } from '../../../../../../store/helpers/initStore.js';

const NONE = 'None';
const getWaypointAddressOptions = (waypoints) => {
    const options = [{
            waypointID: NONE,
            formmatedAddress: 'No location',
        }];
    const waypointOptions = waypoints.map((waypoint) => {
        var _a, _b;
        return ({
            waypointID: waypoint.id,
            formmatedAddress: (_b = (_a = formatAddressUS(waypoint.location)) !== null && _a !== void 0 ? _a : waypoint.location.formattedAddress) !== null && _b !== void 0 ? _b : '',
        });
    });
    return options.concat(waypointOptions);
};
const getPatientWaypointAddressOptions = (itineraryID) => {
    if (!itineraryID)
        return [];
    const store = getStore();
    const patientWaypoints = store.getters['itineraries/getPatientWaypointsOnItinerary'](itineraryID);
    return getWaypointAddressOptions(patientWaypoints);
};
const getMailInBoxPickupWaypoint = (itineraryID, waypointID) => {
    if (!itineraryID)
        return;
    const store = getStore();
    const patientWaypoints = store.getters['itineraries/getPatientWaypointsOnItinerary'](itineraryID);
    return patientWaypoints.find((waypoint) => (waypoint === null || waypoint === void 0 ? void 0 : waypoint.mailInWaypointActionID) === waypointID);
};

export { NONE, getMailInBoxPickupWaypoint, getPatientWaypointAddressOptions };
